import { jsx as _jsx } from "react/jsx-runtime";
import deepEqual from 'fast-deep-equal';
import Schema from './Schema';
import { SchemaBuilderContextProvider } from './SchemaContext';
export default function SchemaBuilder({ schema, variablesSchema, referenceCollections, referenceSchemas, isObject = true, readOnly = false, name = '', onChange, className, }) {
    if (!schema) {
        schema = isObject
            ? {
                type: 'object',
            }
            : {};
    }
    if (isObject && (schema === null || schema === void 0 ? void 0 : schema.type) !== 'object') {
        schema = { type: 'object' };
    }
    function handleChange(newSchema) {
        if (!readOnly && onChange && !deepEqual(schema, newSchema)) {
            onChange(newSchema);
        }
    }
    function handleAddProperty() {
        var _a;
        onChange === null || onChange === void 0 ? void 0 : onChange({
            ...schema,
            properties: {
                ...((_a = schema.properties) !== null && _a !== void 0 ? _a : {}),
                ['']: {
                    type: 'string',
                },
            },
        });
    }
    return (_jsx(SchemaBuilderContextProvider, { variablesSchema: variablesSchema, referenceCollections: referenceCollections, referenceSchemas: referenceSchemas, readOnly: readOnly, isObject: isObject, children: _jsx("div", { className: className, children: _jsx(Schema, { name: name, schema: schema, level: 0, onChange: handleChange, onAdd: handleAddProperty }) }) }));
}
//# sourceMappingURL=index.js.map